// pages/AutoLogin.jsx
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { LoginUser } from "../features/authSlice.js";
import { jwtDecode } from "jwt-decode";
// import axios from "../utils/axiosInstance"; // Sesuaikan dengan axios kamu
import { FaSpinner } from "react-icons/fa";
import { API_URL, SECRET_SESSION } from "../constants";
import axios from "axios";
import { encrypt_res, decrypt_res, encrypt } from "./shares/GlobalFunction.jsx";
import moment from "moment-timezone";
import Cookies from "js-cookie";

const baseURL = API_URL + "/login/autologin";

export default function AutoLogin() {
  const navigate = useNavigate();

  
const params = new URLSearchParams(window.location.search);
const token_jwt = params.get("token");
useEffect(() => {
    if (token_jwt) {
        try {
            const decoded = jwtDecode(token_jwt);  
            const {username, password} = decoded;
            const payload = {
                username: username,
                password: password,
                // token: token,
                timePost: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
            };

            const encryptedPayload = encrypt_res(
                JSON.stringify(payload),
                SECRET_SESSION
            );

            axios.post(baseURL, {
                data: encryptedPayload,
            }).then((response) => {
                const decResponse = JSON.parse(decrypt_res(response.data.data, SECRET_SESSION));
                const encryptedData = encrypt(JSON.stringify(decResponse));
                localStorage.setItem("user", encryptedData);
                localStorage.setItem("token", response.data.token);
                Cookies.remove("user-baru");
                navigate("/peserta/confirmdata");
            });

            

            

        } catch (err) {
        console.error("Token tidak valid");
        }
    } else {
    //   navigate("/login");
    }
},[navigate, token_jwt]);

  return <div className="flex items-center justify-center min-h-screen bg-gray-100 ">
      <div className="bg-white p-8 rounded-lg shadow-lg text-center">
        <p className="text-lg text-gray-700">
          Sedang memverifikasi data anda. <br />Silakan tunggu ...
        </p>
      </div>
    </div>;
}
